import React, { useRef, useEffect } from "react";
import { Form, Input, Typography, Button } from "antd";
import { useIntl } from "react-intl";
import { PhoneMultiFactorGenerator } from "firebase/auth";
const { Text } = Typography;

const TwoFAContent = (props) => {
  const {
    phoneNumber,
    onCodeChange,
    twoFAError,
    twoFACode,
    activeFactorId,
    hasMobileFactor,
    switchToMobileAuthantication,
  } = props;
  const [form] = Form.useForm();
  const intl = useIntl();
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef?.current && inputRef?.current?.input) {
      inputRef.current.focus({
        cursor: "end",
      });
    }

    if (!twoFACode) {
      form.resetFields();
    }
  }, [inputRef, form, twoFACode]);

  const onChange = (e) => {
    onCodeChange(e.target.value);
  };

  const type =
    activeFactorId === PhoneMultiFactorGenerator.FACTOR_ID ? "mobile" : "totp";

  return (
    <div>
      <div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {type === "mobile" ? (
            <Text style={{ paddingBottom: "20px" }}>{`${intl.formatMessage({
              id: "app.forms.user.2faCodeInstructions",
            })}${phoneNumber.substr(phoneNumber.length - 4)}********`}</Text>
          ) : (
            <Text style={{ paddingBottom: "20px" }}>{`${intl.formatMessage({
              id: "app.forms.user.2faTotpInstructions",
            })}`}</Text>
          )}

          <div style={{ justifyContent: "center", width: "100px" }}>
            <Input
              allowClear={true}
              ref={inputRef}
              onChange={onChange}
              size="large"
              style={{ borderColor: "#000000" }}
              value={twoFACode}
            />
          </div>

          {type === "totp" && hasMobileFactor && (
            <Button
              key="switch"
              onClick={switchToMobileAuthantication}
              type="link"
              style={{ marginTop: "10px" }}
            >
              {intl.formatMessage({
                id: "app.forms.user.switchToMobileAuthantication",
              })}
            </Button>
          )}

          {twoFAError ? (
            <p
              style={{
                margin: "10px 0 20px ",
                width: "300px",
                color: "#a61d24",
                textAlign: "center",
              }}
            >
              {twoFAError
                ? intl.formatMessage({
                    id: `app.notifications.${twoFAError}`,
                    defaultMessage: twoFAError,
                  })
                : ""}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default TwoFAContent;
